export const PARTICIPANT_ROLE = 'Participant';
export const CLIENT_USER_ROLE = 'Client User';
export const CLIENT_ADMIN_ROLE = 'Client Admin';
export const SUPER_ADMIN_ROLE = 'RE superadmin';
export const ENGINEERING_ROLE = 'RE engineering';

export const USER_ROLES = [PARTICIPANT_ROLE, CLIENT_USER_ROLE, CLIENT_ADMIN_ROLE, SUPER_ADMIN_ROLE, ENGINEERING_ROLE];
